import { FC, MouseEvent, ReactElement, ReactNode, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { OnyxiaTooltip } from 'ui/components/tooltip'
import theme from 'theme'

interface FrameworkRemovedTooltipProps {
  children: ReactElement
  message: string
  onFrameworkChange?: () => Promise<void>
  placement?: 'bottom-start' | 'bottom-end' | 'bottom' | 'top' | 'top-start' | 'top-end'
}

const FrameworkRemovedTooltip: FC<FrameworkRemovedTooltipProps> = ({
  children,
  message,
  onFrameworkChange,
  placement = 'bottom-start'
}) => {
  const [isChangingFramework, setIsChangingFramework] = useState(false)

  const handleChangeClick = async (e: MouseEvent) => {
    e.stopPropagation()
    if (onFrameworkChange && !isChangingFramework) {
      setIsChangingFramework(true)
      await onFrameworkChange()
      setIsChangingFramework(false)
    }
  }

  const content: ReactNode = (
    <Box>
      <Typography sx={{ fontSize: theme.typography.fontSize.medium, lineHeight: '18px' }}>{message}</Typography>
      {onFrameworkChange && (
        <Typography
          component="span"
          onClick={handleChangeClick}
          sx={{
            display: 'inline-block',
            marginTop: '8px',
            fontSize: theme.typography.fontSize.medium,
            lineHeight: '18px',
            color: theme.colors.buttonHollowHover,
            cursor: 'pointer',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          {isChangingFramework ? 'Updating...' : 'Change to current framework'}
        </Typography>
      )}
    </Box>
  )

  return (
    <OnyxiaTooltip arrow placement={placement} title={content as unknown as string}>
      {children}
    </OnyxiaTooltip>
  )
}

export default FrameworkRemovedTooltip
